<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M27.3327 7.68866C25.7899 7.68866 23.4639 9.28547 21.5177 10.8823C18.9781 12.9722 16.8182 15.4614 15.1568 18.2793C13.8988 20.3927 12.7121 22.9758 12.7121 25.0658M12.6884 25.0664C12.6884 23.9393 12.0238 22.5068 11.3355 21.3562C10.4098 19.8063 9.22308 18.4443 7.84647 17.3172C6.77841 16.4248 5.52047 15.556 4.66602 15.556"
      stroke="#ED166E"
      stroke-width="2"
      stroke-miterlimit="10"
    />
  </svg>
</template>
